module.exports = __webpack_public_path__ + "static/Tile1-infrared-80cac7c2b386ac4a91ca3310b1d86216.gif";